import React, { Fragment, useContext, useState } from "react";
import {
  Avatar,
  Typography,
  Paper,
  IconButton,
  Button,
  Grid,
  Box,
} from "@mui/material";
import Editor from "../../../utils/common/Editor";
import CloseIcon from "@mui/icons-material/Close";
// import EmailGenerate from "./EmailGenerate";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { Http, appLogger } from "../../../utils";
import { UserLoginInfo } from "../../../types/context";
import { UserContext } from "../../../context/userContext";
import { withSnackbar } from "../../../utils/common/SnackbarHoc";
import _ from "lodash";
import NameAndEmail from "../../../utils/common/NameAndEmail";

const BulkEmailReplyEditor = (props: any) => {
  const { userInfo } = useContext(UserContext) as UserLoginInfo;
  const {
    onDelete,
    ticketId,
    updateEmailList,
    feedbackDetails,
    lastEmailId,
    lastEmailAvatar,
    updateStatus,
    EmailSaluation,
    EmailSignature,
    feedbackIds,
    feedbackFullDatas,
    closeBulkEmailReply,
    setSelected,
  } = props;
  const [loader, setLoader] = useState(false);
  const initialContent = "<br><br><br><br><br><br><br>"; // Add some empty lines for space at the top
  const [editorData, setEditorData] = useState(
    (EmailSaluation != "" ? _.unescape(EmailSaluation) : "") +
      (EmailSignature != "" ? initialContent + _.unescape(EmailSignature) : "")
  );
  const [sendBtnDisabled, setsendBtnDisabled] = useState(true);

  const onDeleteAction = () => {
    // onDelete(false);
    closeBulkEmailReply();
  };
  const forwardIcon = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.28009 0.969592C4.4207 1.11024 4.49968 1.30097 4.49968 1.49984C4.49968 1.69871 4.4207 1.88944 4.28009 2.03009L2.56034 3.74984H6.74985C8.14223 3.74984 9.4776 4.30297 10.4621 5.28753C11.4467 6.27207 11.9999 7.60744 11.9999 8.99982V10.4998C11.9999 10.6987 11.9208 10.8895 11.7802 11.0301C11.6396 11.1708 11.4488 11.2498 11.2499 11.2498C11.051 11.2498 10.8602 11.1708 10.7195 11.0301C10.5788 10.8895 10.4999 10.6987 10.4999 10.4998V8.99982C10.4999 8.00524 10.1048 7.05147 9.40148 6.3482C8.6982 5.64493 7.74443 5.24984 6.74985 5.24984H2.56034L4.28009 6.96957C4.35173 7.03879 4.40886 7.12152 4.44817 7.21302C4.48748 7.30452 4.50816 7.40299 4.50903 7.50252C4.50989 7.60212 4.49092 7.70089 4.45321 7.79307C4.4155 7.88524 4.3598 7.96895 4.28939 8.03937C4.21897 8.1098 4.13523 8.16552 4.04306 8.20324C3.95088 8.24089 3.85212 8.25987 3.75254 8.25904C3.65296 8.25814 3.55454 8.23744 3.46304 8.19814C3.37154 8.15884 3.28877 8.10169 3.21959 8.03007L0.219592 5.03009C0.07899 4.88944 0 4.69871 0 4.49984C0 4.30097 0.07899 4.11024 0.219592 3.96959L3.21959 0.969592C3.36023 0.82899 3.55097 0.75 3.74984 0.75C3.94871 0.75 4.13945 0.82899 4.28009 0.969592Z"
          fill="#757775"
        />
      </svg>
    );
  };
  const handleOnChange = (value: any) => {
    setEditorData(value);
  };
  // console.log(editorData, "editorData");
  const sendMail = async () => {
    const pattern1 =
      /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
    const str1 = editorData.replace(
      pattern1,
      "<a style='color:#1b66e6' target='_blank' href='$1'>$1</a>"
    );
    // console.log(str1, "str1---");
    const pattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
    const str2 = str1.replace(
      pattern2,
      '$1<a style="color:#1b66e6"  target="_blank" href="https://$2">https://$2</a>'
    );

    const body = {
      body: editorData,
      feedbackId: feedbackIds,
      // base64: base64,
      // filename: fileName,
      // cc: newCC,
    };
    setLoader(true);
    await Http.post({
      url: `/api/v2/mailing/`,
      body,
      state: userInfo,
    });
    // updateStatus("inprogress");
    setLoader(false);
    props.snackbarShowMessage("Email sent successfully", "success", 3000);
    setTimeout(() => {
      closeBulkEmailReply();
      setSelected([]);
    }, 1500);
    // closeBulkEmailReply();
    // updateEmailList();
    appLogger.info(
      {
        infoObj: {
          method: "sendMail",
          component: "mailing",
          fileName: "mailimgDrawer.tsx",
        },
      },
      "Mail Send"
    );
  };
  const handleInsertReply = (value: any) => {
    setEditorData(
      (EmailSaluation != "" ? _.unescape(EmailSaluation) : "") +
        "<br><br>" +
        value +
        "<br>" +
        (EmailSignature != "" ? _.unescape(EmailSignature) : "")
    );
    // setEditorData((prevState) => prevState + value);
  };
  const isEditorEmpty = () => {
    const plainText = editorData.replace(/<[^>]+>/g, "");
    return plainText.trim().length === 0;
  };
  const FormattedReplyEmails = () => {
    if (!feedbackFullDatas?.length) return null;

    const uniqueEmails = [
      ...new Set(feedbackFullDatas.map((f: any) => f.userId)),
    ];

    return (
      <>
        {uniqueEmails.map((email: any, i: number) => (
          <Fragment key={email}>
            <NameAndEmail text={email} />
            {i < uniqueEmails.length - 1 ? (
              <span style={{ opacity: 0.65 }}>, </span>
            ) : null}
          </Fragment>
        ))}
      </>
    );
  };

  return (
    <Grid
      sx={{
        display: "flex",
        position: "absolute",
        top: "100px",
        right: 0,
        width: "70vw",
        minWidth: "380px",
        // maxHeight: "calc(100vh - 200px)", // Adjust maxHeight as needed
        // overflow: "auto", // Enable scrolling if content exceeds height
        "&::before": {
          content: '""',
          position: "fixed",
          zIndex: 1,
          left: 0,
          right: 0,
          top: 0,
          bottom: 0,
          background: "#0157ff1a",
        },
      }}
      className={loader ? "loader" : ""}
    >
      {/* <Avatar className="emailsenderavatar">{lastEmailAvatar}</Avatar> */}
      <Paper
        sx={{
          zIndex: 2,
          width: "100%",
          margin: "10px",
          flexGrow: 1,
          // padding:"15px 24px 24px 24px"
          mt: 3,
          borderRadius: "14px",
          boxShadow:
            "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;",
        }}
      >
        <Typography
          sx={{
            borderBottom: "1px solid #cccccc87",
            justifyContent: "end",
            padding: "7px 24px 6px 0px",
            background: "#f2efef52",
            display: "flex",
            borderTopLeftRadius: "14px", // Set radius for top-left corner
            borderTopRightRadius: "15px",
          }}
        >
          <IconButton
            onClick={closeBulkEmailReply}
            aria-label="search icon"
            edge="end"
            className="search-fb-icon"
          >
            <CloseIcon className="cursor-pointer" />
          </IconButton>
        </Typography>
        <Grid
          container
          spacing={2}
          sx={{
            padding: "15px 24px 24px 24px",
          }}
        >
          <Grid item xs={12} md={12} sx={{ position: "relative" }}>
            <Grid
              container
              item
              xs={12}
              alignItems="center"
              gap="11px"
              sx={{
                pb: 1,
                // borderBottom: "1px solid rgba(0, 0, 0, 0.2)",
              }}
            >
              <Box>{forwardIcon()}</Box>
              <Box
                sx={{
                  maxWidth: "100%",
                  flex: 1,
                  pl: 1,
                  wordWrap: "break-word",
                  fontSize: "14px",
                  color: "#3D4043",
                }}
              >
                <FormattedReplyEmails />
              </Box>
            </Grid>
            <Grid sx={{ mt: 2 }}>
              <Editor
                editorData={editorData}
                updateData={handleOnChange}
                className="emailReplyEditorArea"
              />
            </Grid>
            <Grid
              container
              item
              xs={12}
              mt="10px"
              justifyContent="space-between"
            >
              <Box display="flex" gap="10px">
                <Button
                  disabled={isEditorEmpty()}
                  sx={{
                    borderRadius: "8px",
                  }}
                  variant="contained"
                  startIcon={
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="14"
                      viewBox="0 0 16 14"
                      fill="none"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M7.67325 4.00801C3.57471 5.9369 0.191713 7.53777 0.155454 7.56552C0.119194 7.59328 0.0677387 7.66166 0.0410747 7.7175C0.00135883 7.80074 -0.00541816 7.83715 0.00344407 7.91957C0.0157624 8.03404 0.086776 8.16433 0.166575 8.21882C0.271705 8.29063 4.15641 10.054 4.17663 10.0391C4.18783 10.0308 5.81303 8.75028 7.78821 7.19337C9.76338 5.63648 11.5011 4.26677 11.6497 4.1496C11.9113 3.94348 11.8902 3.96556 11.0029 4.82851C10.4985 5.3191 8.97096 6.79539 7.60836 8.10918L5.13089 10.4979L5.18524 10.5245C5.21513 10.5392 6.32691 11.0481 7.65585 11.6554C10.0049 12.7288 10.0753 12.7595 10.1852 12.7591C10.3277 12.7586 10.4365 12.7124 10.52 12.617C10.5704 12.5595 11.0899 11.3199 12.9951 6.71149C14.3213 3.5035 15.4163 0.844276 15.4285 0.802124C15.4719 0.651591 15.3529 0.497946 15.1947 0.500021C15.1424 0.500725 13.271 1.37353 7.67325 4.00801ZM5.1334 12.3393C5.1334 13.2406 5.13579 13.3108 5.16868 13.3696C5.18808 13.4043 5.23357 13.4479 5.26975 13.4665C5.39548 13.5312 5.43281 13.5181 5.79461 13.2828C6.92917 12.5446 7.23352 12.3414 7.22193 12.3299C7.21 12.3179 5.5312 11.5458 5.25407 11.4248L5.1334 11.3721V12.3393Z"
                        fill="white"
                      />
                    </svg>
                  }
                  onClick={sendMail}
                >
                  SEND
                </Button>
                {/* <IconButton>
                    <AttachFileIcon />
                  </IconButton> */}
              </Box>
              <Box>
                <IconButton onClick={onDeleteAction}>
                  <DeleteOutlineIcon />
                </IconButton>
              </Box>
            </Grid>
          </Grid>
          {/*  <Grid item xs={12} md={4}>
             <EmailGenerate
                handleInsertReply={handleInsertReply}
                feedbackDetails={feedbackDetails}
              /> 
            </Grid>*/}
        </Grid>
      </Paper>
    </Grid>
  );
};

export default withSnackbar(BulkEmailReplyEditor);
